<template>
  <el-dialog title="查看用户详情" :visible.sync="dialogVisible" width="600px">
    <div class="wrapper">
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="label">用户头像</div>
          <div class="value">
            <img :src="user.face" class="avatar" />
          </div>
        </el-col>
        <el-col :span="12">
          <div class="label">用户昵称</div>
          <div class="value">{{ user.nickname }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="label">用户性别</div>
          <div class="value">{{ ['男', '女'][user.sex] }}</div>
        </el-col>
        <el-col :span="12">
          <div class="label">手机号</div>
          <div class="value">{{ user.mobile }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="label">考研年份</div>
          <div class="value">{{ user.pubmed_year }}</div>
        </el-col>
        <el-col :span="12">
          <div class="label">年级</div>
          <div class="value">{{ user.grade }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="label">就读学校</div>
          <div class="value">{{ user.school }}</div>
        </el-col>
        <el-col :span="12">
          <div class="label">就读专业</div>
          <div class="value">{{ user.major }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="label">报考学校</div>
          <div class="value">{{ user.target }}</div>
        </el-col>
        <el-col :span="12">
          <div class="label">报考院系</div>
          <div class="value">{{ user.department }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="label">报考专业</div>
          <div class="value">{{ user.target_major }}</div>
        </el-col>
        <el-col :span="12">
          <div class="label">用户身份</div>
          <div class="value">{{ user.user_type === 'student' ? '学生' : '家长' }}</div>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>

<script>
import { getDetail } from '@/api/user'
export default {
  name: 'UserDetail',
  data() {
    return {
      dialogVisible: false,
      uuid: '',
      user: {},
    }
  },
  methods: {
    handleDetail(uuid) {
      getDetail(uuid).then((res) => {
        this.uuid = uuid
        Object.assign(this.user, res.data)
        this.dialogVisible = true
      })
    },
  },
}
</script>

<style lang="less" scoped>
.wrapper {
  margin: 0 20px 20px;
  line-height: 2;
}
.el-row {
  margin-bottom: 1.5em;
}
.label {
  width: 100px;
  text-align: right;
  float: left;
  margin-right: 15px;
  &:after {
    content: '：';
  }
}
.value {
  overflow: hidden;
}
.avatar {
  width: 50px;
  height: 50px;
}
</style>
